import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const GreenvaleCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Greenvale" suburbSlug="greenvale" variant="cdbs-dentist" />
);

export default GreenvaleCdbsDentistPage;
